// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/inflight-physiological-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/inflight-physiological-hazards/inflight-physiological-hazards.js';

mount([g0]);
